import { FC, useContext } from 'react';
import { inflect } from 'inflection';
import { TableContext, TableDrawerName } from './';
import styles from './FilterSummary.module.css';

/* 
  If there are no applicable filters, this component returns null.
  If there are quick filters, the number of applicable filters is displayed with a '+' prefix.
  Otherwise, the number of applicable filters is displayed.
*/
export const FilterSummary: FC = () => {
  const {
    filterSummaryInfo: {
      hasQuickFilters,
      numApplicableFilters
    },
    setDrawer
  } = useContext(TableContext);
  if (numApplicableFilters === 0) return null;
  const onClick = () => setDrawer({
    name: TableDrawerName.AllFilters
  });
  const text = `${hasQuickFilters ? '+' : ''}${numApplicableFilters} ${inflect('filter', numApplicableFilters)}`;
  return <button className={styles.filterSummary} onClick={onClick} data-sentry-component="FilterSummary" data-sentry-source-file="FilterSummary.tsx">
      {text}
    </button>;
};